module.exports = __webpack_public_path__ + "media/images/home/bradley_anthony-2e08d55ae2fe36a36147f77a1f70dd9a.jpeg";